import { DecisionTree } from './DecisionTree.js';

class Decision {
  constructor(condition, action) {
    this.condition = condition;
    this.action = action;
  }
  evaluate(data, depth) {
    const currentData = data[depth];
    if (this.condition(currentData)) {
      if (typeof this.action === 'function') {
        return this.action(data, depth);
      } else if (this.action instanceof DecisionTree) {
        return this.action.evaluate(data, depth + 1);
      }
      return this.action;
    }
    return null;
  }
}

export { Decision };
//# sourceMappingURL=Decision.js.map
